import { MAX_LAST_COMMUNICATION_DIFF_MS } from "../config/constants";

export function getOnlineOfflineDevices(hardwares) {
	const onlineHardwares = [];
	const offlineHardwares = [];

	for (const hardware of hardwares) {
		if (isHardwareOnline(hardware)) {
			onlineHardwares.push(hardware);
		} else {
			offlineHardwares.push(hardware);
		}
	}

	return {
		onlineHardwares,
		offlineHardwares,
	}
}

export function isHardwareOnline(hardware) {
	if (!hardware || !hardware.lastCommunication) return false;
	const lastCommDiff = Date.now() - new Date(hardware.lastCommunication).getTime();
	return lastCommDiff <= MAX_LAST_COMMUNICATION_DIFF_MS;
}